<template>
  <el-dialog
    :model-value="visible"
    :title="`项目详情 - ${project?.name || ''}`"
    width="600px"
    draggable
    @update:model-value="$emit('update:visible', $event)"
  >
    <template v-if="project">
      <el-descriptions :column="1" border label-width="100px">
        <el-descriptions-item label="项目名称">{{
          project.name
        }}</el-descriptions-item>
        <el-descriptions-item label="类型">
          {{ project.type === "image" ? "镜像项目" : "构建项目" }}
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="getStatus(project.status).color">
            {{ getStatus(project.status).label }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="环境" v-if="envName">{{
          envName
        }}</el-descriptions-item>

        <template v-if="project.type === 'image'">
          <el-descriptions-item label="镜像">{{
            project.image
          }}</el-descriptions-item>
          <el-descriptions-item label="辅助参数">
            <pre>{{ JSON.stringify(project.extra, null, 2) }}</pre>
          </el-descriptions-item>
        </template>
        <template v-else>
          <el-descriptions-item label="Git仓库">
            <el-link
              :href="project.detail?.gitRepo"
              target="_blank"
              underline
              >{{ project.detail?.gitRepo }}</el-link
            >
          </el-descriptions-item>
          <el-descriptions-item label="分支">{{
            project.detail?.branch
          }}</el-descriptions-item>
          <el-descriptions-item label="构建目录">{{
            project.detail?.buildDir
          }}</el-descriptions-item>
          <el-descriptions-item label="依赖项目">
            <div
              v-for="(p, i) in project.depends"
              :key="i"
              class="flex items-center"
            >
              git仓库：
              <el-text class="w-[250px]" truncated>
                <el-link :href="p.gitRepo" target="_blank">
                  {{ p.gitRepo }}
                </el-link>
              </el-text>
              <el-divider direction="vertical"></el-divider>
              <span>分支：{{ p.branch }}</span>
            </div>
          </el-descriptions-item>
        </template>
        <el-descriptions-item label="项目路径">
          {{ project.projectPath }}
        </el-descriptions-item>
        <el-descriptions-item label="commit">
          {{ project.commit }}
        </el-descriptions-item>
        <el-descriptions-item label="端口映射">
          <div v-for="(p, i) in project.portMaps" :key="i">
            {{ p.hostPort }} -> {{ p.containerPort }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="卷映射">
          <div v-for="(v, i) in project.volumeMaps" :key="i">
            {{ v.hostPath }} -> {{ v.containerPath }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">
          {{ new Date(project.createAt * 1000).toLocaleString("zh-CN") }}
        </el-descriptions-item>
      </el-descriptions>
    </template>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="$emit('update:visible', false)">关闭</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { watch } from "vue";
import type { Project } from "../types";
import { getStatus } from "./utils";

const props = defineProps<{
  visible: boolean;
  project: Project | null;
  envName?: string;
}>();
watch(
  () => props.project,
  (newProject) => {
    if (newProject) {
      console.log(newProject);
    }
  },
);
defineEmits<{
  (e: "update:visible", value: boolean): void;
}>();
</script>
